import type { AutoReplyAction as AutoReplyActionType } from "@redotech/redo-flows-common/rules/schemas";
import { memo } from "react";
import { SupportV2AutoReplyAction } from "./auto-reply-action";

/** Renders the Plate (support-v2) auto-reply editor. */
export const AutoReplyActionSwitch = memo(
  function AutoReplyActionSwitch(props: {
    action: AutoReplyActionType;
    onChange: (updated: AutoReplyActionType) => void;
    editableFields?: ReadonlySet<string>;
  }) {
    return <SupportV2AutoReplyAction {...props} />;
  },
);
